export const EDIT_WORKFLOW = {

  'MODAL': {
    'CONTENT': 'Voulez-vous vraiment supprimer ce workflow ? Cette action est irréversible.'
  }

};
